// Start your code from here for component inlinechart-query-builder
import _ from 'underscore';
import * as Constants from './constants';

export class InlineChartRequest {
  constructor(options) {
    this.edm = options.edm;
    this.state = options.state;
    this.pageContext = options.pageContext;
  }

  getParentLevels = () => {
    const currentCampaign = this.pageContext.CurrentCampaign;
    const currentAdGroup = this.pageContext.CurrentAdGroup;
    const parentLevels = [];

    if (currentCampaign) {
      parentLevels.push({
        name: Constants.EdmEntityName.CampaignEdmEntity,
        id: currentCampaign.Id,
      });
    }

    if (currentAdGroup) {
      parentLevels.push({
        name: Constants.EdmEntityName.AdGroupEdmEntity,
        id: currentAdGroup.Id,
      });
    }

    return parentLevels;
  };

  getDefaultEntityBaseOnParentLevels = (parentLevels) => {
    let entity = Constants.EntityName.CampaignEntity;
    const currentCampaign = this.pageContext.CurrentCampaign;
    const isPerfMaxCampaign = _.findWhere(currentCampaign?.CampaignSettings, { '@odata.type': '#Model.PerformanceMaxSetting' });
    const isAppCampaign = _.findWhere(currentCampaign?.CampaignSettings, { '@odata.type': '#Model.AppSetting' });

    if (parentLevels && parentLevels.constructor === Array && parentLevels.length > 0) {
      if (parentLevels[parentLevels.length - 1].name ===
        Constants.EdmEntityName.AdGroupEdmEntity) {
        entity = Constants.EntityName.AdEntity;
      } else if (parentLevels[parentLevels.length - 1].name ===
        Constants.EdmEntityName.CampaignEdmEntity) {
        if (isPerfMaxCampaign || isAppCampaign) {
          entity = Constants.EntityName.AssetGroupEntity;
        } else {
          entity = Constants.EntityName.AdGroupEntity;
        }
      }
    }

    return entity;
  };

  isFilterActive = (filter) => {
    const filterString = filter && filter.odataV4 ?
      filter.odataV4({ ignoreCase: false }) : '';
    return (!!filterString);
  };

  getCurrentEntity = (entity, filter) => {
    if (_.contains(Constants.PersistentEntity, entity)) {
      return entity;
    }

    // When there is no filter applied, PerformanceTimeSerieis request for all entities
    // (Adsgroup, Ads, Kewords) needs to query on Campaign entity inorder to improve
    // MT performance.
    // the PerformanceData fetched is for Account or Campaign based on the parent level.
    // Always use default parent entity if current entity is SearchTerm
    if (!this.isFilterActive(filter) || entity === Constants.EntityName.SearchTermEntity) {
      // No filters or SearchTerm use default parent entity
      return this.getDefaultEntityBaseOnParentLevels(this.getParentLevels());
    }
    return entity || this.getDefaultEntityBaseOnParentLevels(this.getParentLevels());
  };

  formatDateString = (dateStr) => {
    const leftPadding = s => ((s.length === 1) ? `0${s}` : s);
    const dt = new Date(Date.parse(dateStr));
    const year = `${dt.getFullYear()}`;
    const month = `${dt.getMonth() + 1}`;
    const day = `${dt.getDate()}`;

    return `${year}-${leftPadding(month)}-${leftPadding(day)}`;
  };

  getEntityCollectionName = (name) => {
    const nameMapping = {
      Campaign: Constants.EdmEntityName.CampaignEdmEntity,
      Keyword: Constants.EdmEntityName.KeywordEdmEntity,
      Account: Constants.EdmEntityName.AccountEdmEntity,
      // Negative keywords also show keyword performance trend
      NegativeKeyword: Constants.EdmEntityName.KeywordEdmEntity,
      // Negative keyword lists also show keyword performance trend
      NegativeKeywordList: Constants.EdmEntityName.KeywordEdmEntity,
      AdGroup: Constants.EdmEntityName.AdGroupEdmEntity,
      AssetGroup: Constants.EdmEntityName.AssetGroupEdmEntity,
      Ad: Constants.EdmEntityName.AdEdmEntity,
      CampaignCriterion: Constants.EdmEntityName.CampaignCriterionEdmEntity,
      AdGroupCriterion: Constants.EdmEntityName.AdGroupCriterionEdmEntity,
      AudienceCriterionWithBI: Constants.EdmEntityName.AudienceCriterionWithBIEdmEntity,
      DsaTarget: Constants.EdmEntityName.DsaTargetEdmEntity,
      PortfolioBidStrategy: Constants.EdmEntityName.PortfolioBidStrategyEdmEntity,
    };

    if (nameMapping[name]) {
      return nameMapping[name];
    }
    return name;
  };

  generateRequest = (context, metric) => {
    const request = {};
    const entity = context.currentEntity
      ? this.getCurrentEntity(context.currentEntity, context.filter)
      : Constants.EntityName.CampaignEntity;

    let accountModes = null;
    if (entity === Constants.EntityName.AccountEntity
      && this.pageContext.CurrentTabId === 'Performance') {
      if (this.pageContext.CurrentGridName === 'SmartPerformanceGrid') {
        accountModes = 'Smart';
      } else if (this.pageContext.CurrentGridName === 'PerformanceGrid') {
        accountModes = 'Expert';
      }
    }

    if (entity === Constants.EntityName.CampaignEntity ||
      entity === Constants.EntityName.AdGroupEntity ||
      entity === Constants.EntityName.AdEntity ||
      entity === Constants.EntityName.KeywordEntity) {
      request.currentCustomerId = this.pageContext.CurrentCustomer.Id;
    }

    _.extend(request, {
      parentLevels: this.getParentLevels(),
      edmEntity: this.getEntityCollectionName(entity),
      entity,
      startDate: context.period
        ? this.formatDateString(context.period.start)
        : null,
      endDate: context.period
        ? this.formatDateString(context.period.end)
        : null,
      compareStartDate: context.period && context.period.compared
        ? this.formatDateString(context.period.compared.start)
        : null,
      compareEndDate: context.period && context.period.compared
        ? this.formatDateString(context.period.compared.end)
        : null,
      granularity: context.granularity,
      metrics: context.metric || metric,
      filters: context.currentEntity === Constants.EntityName.SearchTermEntity
        ? null // Ignore filters on SearchTerm
        : context.filter,
      movingAverage: context.isMovingAverageOn,
    });
    if (accountModes) {
      _.extend(request, {
        accountModes,
      });
    }
    return request;
  };

  getQuery = context => this.generateRequest(context, 'All');
}
